import { Button } from "@cti-workspace/ui";
import { Fingerprint } from "@phosphor-icons/react";

const FabricCopyId = ({ setCopyRendererConfigId }) => {
	return <Fingerprint onClick={setCopyRendererConfigId} size={17} />;
};

export default FabricCopyId;
